module.exports = __webpack_public_path__ + "img/border_brackets.95724ed8.svg";